// The window arithmetic, split out so it can be imported by a test without
// dragging React in. monthEndLock.js re-exports these; there is one copy.

export const LOCK_BUSINESS_DAYS = 3;

// ONE MORE, BECAUSE THIS DOES NOT KNOW BANK HOLIDAYS. Counting weekdays alone
// places "two business days before month end" LATER in the month than it really
// falls whenever a holiday lands in the window — which would leave the actual
// invoice day outside the warning, on the one month it mattered most. Erring
// wide costs a dialog somebody dismisses. Erring narrow costs the reconciliation
// this whole file exists to prevent.
export const LOCK_HOLIDAY_SLACK = 1;

// Weekdays remaining from `d` to the last day of its month, counting `d` itself.
// Local dates on purpose: the business day is the firm's, not UTC's.
export function businessDaysToMonthEnd(d = new Date()) {
  const y = d.getFullYear(), m = d.getMonth();
  const last = new Date(y, m + 1, 0).getDate();
  let n = 0;
  for (let day = d.getDate(); day <= last; day++) {
    const dow = new Date(y, m, day).getDay();
    if (dow !== 0 && dow !== 6) n++;
  }
  return n;
}

export function inMonthEndLock(d = new Date()) {
  return businessDaysToMonthEnd(d) <= LOCK_BUSINESS_DAYS + LOCK_HOLIDAY_SLACK;
}

